module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [(!_vm.error) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "calc(100vh - 106px)"
    },
    attrs: {
      "element-loading-text": "加载中..."
    }
  }, [_c('section', {
    staticClass: "hero-banner"
  }, [_c('div', {
    staticClass: "carousel-container"
  }, [_c('div', {
    staticClass: "carousel-track",
    style: ({
      transform: ("translateX(-" + (_vm.bannerMark * 100) + "%)")
    })
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "carousel-indicators"
  }, _vm._l((2), function(i) {
    return _c('span', {
      key: i,
      class: {
        active: _vm.bannerMark === i - 1
      },
      on: {
        "click": function($event) {
          _vm.bannerMark = i - 1
        }
      }
    })
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "carousel-arrow carousel-prev",
    on: {
      "click": _vm.prevBanner
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "carousel-arrow carousel-next",
    on: {
      "click": _vm.nextBanner
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "activity-panel w reveal-on-scroll",
    attrs: {
      "data-reveal": "fade-up"
    }
  }, [_c('div', {
    staticClass: "catalog-grid"
  }, _vm._l((_vm.catalogList), function(item, j) {
    return _c('div', {
      key: j,
      staticClass: "catalog-item",
      on: {
        "click": function($event) {
          return _vm.linkToCatalog(j)
        }
      }
    }, [_c('img', {
      staticClass: "catalog-img",
      attrs: {
        "src": item.iconSelect,
        "alt": item.name
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "catalog-name"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]), _vm._v(" "), _c('section', {
    staticClass: "news-panel w reveal-on-scroll",
    attrs: {
      "data-reveal": "fade-up"
    }
  }, [_c('div', {
    staticClass: "news-showcase"
  }, [_c('div', {
    staticClass: "news-left"
  }, [_c('div', {
    staticClass: "news-left-carousel"
  }, [_vm._l((_vm.showcaseList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "news-slide",
      class: {
        active: _vm.showcaseMark === i
      },
      on: {
        "click": function($event) {
          return _vm.onShowcaseClick(item)
        }
      }
    }, [(item.__src) ? _c('img', {
      attrs: {
        "src": item.__src,
        "alt": item.newsTitle
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.showcaseList.length === 0) ? _c('div', {
    staticClass: "news-left-empty"
  }, [_c('i', {
    staticClass: "el-icon-picture-outline"
  }), _vm._v(" "), _c('p', [_vm._v("暂无热点新闻")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "news-left-indicators"
  }, _vm._l((_vm.showcaseList), function(item, i) {
    return _c('span', {
      key: i,
      class: {
        active: _vm.showcaseMark === i
      },
      on: {
        "click": function($event) {
          _vm.showcaseMark = i
        }
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "news-right"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "news-list"
  }, [_vm._l((_vm.newsList), function(item, i) {
    return _c('li', {
      key: item.newsId !== undefined ? item.newsId : i,
      on: {
        "click": function($event) {
          return _vm.onShowcaseClick(item)
        }
      }
    }, [_c('span', {
      staticClass: "news-date"
    }, [_vm._v(_vm._s(_vm.formatNewsDate(item.newsTime)))]), _vm._v(" "), _c('span', {
      staticClass: "news-title"
    }, [_vm._v(_vm._s(item.newsTitle))]), _vm._v(" "), _c('span', {
      staticClass: "news-arrow"
    }, [_vm._v("→")])])
  }), _vm._v(" "), (_vm.newsList.length === 0) ? _c('li', {
    staticClass: "news-empty"
  }, [_vm._v("暂无新闻")]) : _vm._e()], 2)])])]), _vm._v(" "), _c('section', {
    staticClass: "mall-panel w reveal-on-scroll",
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "data-reveal": "fade-up"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "mall-panel-box"
  }, [_c('ul', {
    staticClass: "left-box"
  }, _vm._l((_vm.mallList), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.onMallClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "mall-card"
    }, [_c('div', {
      staticClass: "mall-card-img"
    }, [_c('img', {
      attrs: {
        "src": item.bg,
        "alt": item.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "mall-card-text"
    }, [_c('h3', {
      staticClass: "mall-card-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "mall-card-en"
    }, [_vm._v(_vm._s(item.enName))])])])])
  }), 0)])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
    staticClass: "link-panel w reveal-on-scroll",
    attrs: {
      "data-reveal": "fade-up"
    }
  }, [_c('div', {
    staticClass: "link-box"
  }, _vm._l((_vm.cataList), function(item, index) {
    return _c('a', {
      key: index,
      staticClass: "link-tile",
      on: {
        "click": function($event) {
          return _vm.openAgree(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "link-icon-wrap"
    }, [_c('i', {
      class: item.icon
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.item))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "header-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticStyle: {
      "padding": "15px 20px"
    }
  }, [_vm._v("认证申请")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "space-around",
      "height": "300px"
    }
  }, [_c('div', {
    staticClass: "item itme1"
  }, [_c('a', {
    on: {
      "click": _vm.factory
    }
  }, [_c('div', {
    staticClass: "t fiex f-18"
  }, [_c('div', {
    staticClass: "t2 center"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/zc11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("诊所/工厂认证")])])]), _vm._v(" "), _c('div', {
    staticClass: "item itme2"
  }, [_c('a', {
    on: {
      "click": _vm.designer
    }
  }, [_c('div', {
    staticClass: "t fiex f-18"
  }, [_c('div', {
    staticClass: "t2 center"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/zc22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("设计师认证")])])])])]), _vm._v(" "), _c('tools', {
    staticClass: "tools",
    staticStyle: {
      "display": "block"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-slide slide-original"
  }, [_c('div', {
    staticClass: "slide-bg",
    staticStyle: {
      "background": "url('https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/match/bg_banner_1.jpg') center center / cover no-repeat"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-content w"
  }, [_c('div', {
    staticClass: "hero-text"
  }, [_c('h1', {
    staticClass: "hero-title"
  }, [_vm._v("AI智能化设计服务")]), _vm._v(" "), _c('p', {
    staticClass: "hero-subtitle"
  }, [_vm._v("数字化口腔智能制造平台")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-slide slide-ai"
  }, [_c('div', {
    staticClass: "slide-bg",
    staticStyle: {
      "background": "url('https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/match/bg_banner_2.jpg') center center / cover no-repeat"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-content w"
  }, [_c('div', {
    staticClass: "hero-text"
  }, [_c('h1', {
    staticClass: "hero-title"
  }, [_vm._v("全自动智能AI生产线")]), _vm._v(" "), _c('p', {
    staticClass: "hero-subtitle"
  }, [_vm._v("齿科数字"), _c('span', {
    staticClass: "hl-blue"
  }, [_vm._v("新基建")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-header"
  }, [_c('h2', [_vm._v("行业新闻")]), _vm._v(" "), _c('span', {
    staticClass: "news-en"
  }, [_vm._v("NEWS & INFORMATION")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-title"
  }, [_c('h1', [_vm._v("功能中心")]), _vm._v(" "), _c('span', {
    staticClass: "title-en"
  }, [_vm._v("FUNCTION CENTER")]), _vm._v(" "), _c('div', {
    staticClass: "title-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "about-panel w reveal-on-scroll",
    attrs: {
      "data-reveal": "fade-up"
    }
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('h1', [_vm._v("关于医小智")]), _vm._v(" "), _c('span', {
    staticClass: "title-en"
  }, [_vm._v("ABOUT US")]), _vm._v(" "), _c('div', {
    staticClass: "title-bar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-main"
  }, [_c('div', {
    staticClass: "footer-intro"
  }, [_c('h3', [_vm._v("尊敬的用户，您好!")]), _vm._v(" "), _c('p', [_vm._v("医小智为您带来全新的齿科在线设计服务，不管您什么时间需要，多远的距离需要，都可以在医小智享受专业高效的义齿设计服务。")]), _vm._v(" "), _c('p', [_vm._v("10秒内完成下单，5分钟反馈数字化扫描数据品质，实时更新临床信息，30分钟完成数字化线上设计，输出制造文件和治疗方案，24小时内免费修改设计方案。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("我们的目标是帮助您及您的客户打造一口健康、美丽的牙齿，让您自信地展开笑容!")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "footer-contact"
  }, [_c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "el-icon-phone-outline"
  }), _vm._v(" "), _c('div', [_c('strong', [_vm._v("服务热线")]), _vm._v(" "), _c('span', [_vm._v("400 088 3316")])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-item"
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" "), _c('div', [_c('strong', [_vm._v("服务时间")]), _vm._v(" "), _c('span', [_vm._v("每天 8:30 ~ 21:30")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/error.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！出错了...\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-625a018b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/home.vue
// module id = 663
// module chunks = 0